<script setup>
import {ref, reactive} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {ElMessage} from 'element-plus'
import {registerApi} from "@/service/index.js";

const store = useStore()
const router = useRouter()
const route = useRoute()
const rules = reactive({
  username: [
    {required: true, message: '请输入用户名', trigger: 'blur'},
    {min: 2, max: 25, message: '请输入正确的用户名', trigger: 'blur'},
  ],
  password: [
    {required: true, message: '请输入密码', trigger: 'blur'},
    {min: 6, max: 25, message: '请输入正确的密码', trigger: 'blur'},
  ],
  email: [
    {required: true, message: '请输入邮箱', trigger: 'blur'},
    {min: 5, max: 25, message: '请输入正确的邮箱', trigger: 'blur'},
  ],
  mobile: [
    {required: true, message: '请输入手机号', trigger: 'blur'},
    {min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur'},
  ],
  invite_code: [
    {required: false, message: '请输入邀请码', trigger: 'blur'},
  ],
  captcha: [
    {required: true, message: '请输入验证码', trigger: 'blur'},
    {min: 4, max: 4, message: '请输入正确的验证码', trigger: 'blur'},
  ],
})
let rForm = ref(null)
let rejisterForm = ref({
  email: '',
  password: '',
  username: '',
  mobile: '',
  invite_code: '',
  captcha: '',// 验证码
  code: '',
  captcha_id: '',	// 调用验证码生成的ID
})
// 与登录一致：时间戳生成验证码ID，点击图片刷新
const updateCaptcha = () => {
  rejisterForm.value.captcha_id = new Date().valueOf().toString().slice(4, -1)
}
const rejiste = async () => {
  await rForm.value.validate((valid, fields) => {
    if (valid) {
      registerApi(rejisterForm.value).then(res => {
        if (res.data.code == 1) {
          ElMessage({
            message: '注册成功',
            type: 'success',
          })
          // 注册成功即自动登录
          store.commit('setUserInfo', res.data.data.userinfo)
          localStorage.setItem('userInfo', JSON.stringify(res.data.data.userinfo))
          // 有 redirect 就回原页面，没有则回首页
          const redirect = route.query.redirect
          const go = (typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//')) ? redirect : '/'
          router.push(go)
        } else {
          ElMessage({
            message: res.data.msg,
            type: 'warning',
          })
          // 注册失败换一张验证码
          rejisterForm.value.captcha = ''
          updateCaptcha()
        }
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}
const toLogin = () => {
  // 回登录页时把 redirect 带回去
  const query = typeof route.query.redirect === 'string' ? {redirect: route.query.redirect} : {}
  router.push({path: '/login', query})
}
updateCaptcha()
</script>

<template>
  <div class="register-box">
    <div class="register-card">
      <div class="register-title">
        <img src="@/assets/ic.png" alt="">
        <span>国际快递单号网 —— TrackCBEC</span>
      </div>
      <el-form :rules="rules" class="register-form" ref="rForm" :model="rejisterForm" label-width="auto"
               @submit.prevent>
        <el-form-item label="用户名" size="large" prop="username">
          <el-input v-model="rejisterForm.username" placeholder="请输入用户名(找回密码需核实)"/>
        </el-form-item>
        <el-form-item label="密码" size="large" prop="password">
          <el-input size="large" v-model="rejisterForm.password" type="password" placeholder="请输入密码"/>
        </el-form-item>
        <el-form-item label="手机号" size="large" prop="mobile">
          <el-input size="large" v-model="rejisterForm.mobile" placeholder="请输入手机号(找回密码需核实)"/>
        </el-form-item>
        <el-form-item label="邮箱" size="large" prop="email">
          <el-input size="large" v-model="rejisterForm.email" placeholder="请输入邮箱(找回密码需核实)"/>
        </el-form-item>
        <el-form-item label="邀请码" size="large" prop="invite_code">
          <el-input size="large" v-model="rejisterForm.invite_code" placeholder="请输入邀请码"/>
        </el-form-item>
        <el-form-item label="验证码" size="large" prop="captcha">
          <div class="captcha-row">
            <el-input size="large" class="captcha-input" v-model="rejisterForm.captcha" placeholder="请输入验证码"/>
            <img :src="'https://aaap.trackcbec.com/index?s=captcha/' + rejisterForm.captcha_id" @click="updateCaptcha"
                 v-if="rejisterForm.captcha_id" class="captcha-pic" alt="">
          </div>
        </el-form-item>
      </el-form>
      <div class="register-foot">
        <span class="foot-link" @click="toLogin">已有账号？去登录</span>
      </div>
      <el-button type="primary" size="large" class="register-btn" @click="rejiste">注 册</el-button>
    </div>
    <p class="disclaimer">本系统只提供界面可视化业务服务，用户应自行核实其准确性。对于因使用本系统而产生的任何法律后果，本公司不承担任何责任。</p>
  </div>
</template>

<style lang="less" scoped>
.register-box {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .register-card {
    width: 500px;
    background: #fff;
    border-radius: 10px;
    padding: 40px 44px 24px;
    box-sizing: border-box;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, .15);
    margin: 40px 0;

    .register-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 30px;

      img {
        width: 40px;
        margin-right: 10px;
      }
    }

    .register-btn {
      width: 100%;
      height: 50px;
      font-size: 18px;
      margin-top: 10px;
    }

    .captcha-row {
      display: flex;
      align-items: center;
      width: 100%;

      .captcha-input {
        flex: 1;
      }

      .captcha-pic {
        width: 120px;
        margin-left: 20px;
        cursor: pointer;
      }
    }

    .register-foot {
      display: flex;
      justify-content: flex-end;
      margin-top: 18px;
      font-size: 14px;

      .foot-link {
        cursor: pointer;
        color: rgb(53, 152, 219);
      }
    }
  }

  .disclaimer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 12px;
    margin: 0;
    padding: 0 24px;
    text-align: center;
    font-size: 12px;
    color: #909399;
    line-height: 1.6;
  }
}
</style>
